var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#00EF8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3796 8.43994H11.5596V11.2599H14.3796V8.43994Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73981 12.3199C8.73981 12.8999 8.25981 13.3799 7.67981 13.3799C7.09981 13.3799 6.6198 12.8999 6.6198 12.3199C6.6198 11.7399 7.09981 11.2599 7.67981 11.2599H8.73981V8.43994H7.67981C5.53981 8.43994 3.7998 10.1799 3.7998 12.3199C3.7998 14.4599 5.53981 16.1999 7.67981 16.1999C9.81981 16.1999 11.5598 14.4599 11.5598 12.3199V11.2599H8.73981V12.3199Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6202 7.0202H15.8002V4.2002H12.6202C10.4802 4.2002 8.74023 5.9402 8.74023 8.0802V8.4402H11.5602V8.0802C11.5602 7.5002 12.0402 7.0202 12.6202 7.0202Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5602 8.43994H8.74023V11.2599H11.5602V8.43994Z",
    fill: "#16FF99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowLogo);
export default __webpack_public_path__ + "static/media/FlowLogo.4a56daf3d39488edbe2c7dd70e229b91.svg";
export { ForwardRef as ReactComponent };